import { createAsyncThunk } from '@reduxjs/toolkit';
import { ApiError, apiFetch } from 'API/apiClient';
import type { ILottery } from 'types/ILottery';
import type { RootState } from 'store/store';

export const fetchLotteries = createAsyncThunk<ILottery[], undefined, { rejectValue: ApiError; state: RootState }>('lotteries/fetchAll', async (_, { rejectWithValue }) => {
  return await apiFetch<ILottery[]>('/lottery', {}, rejectWithValue);
});

export const fetchLottery = createAsyncThunk<ILottery, number, { rejectValue: ApiError; state: RootState }>('lotteries/fetchOne', async (id, { rejectWithValue }) => {
  return await apiFetch<ILottery>(`/lottery/${id}`, {}, rejectWithValue);
});
